import { useEffect, useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useIsFocused from '@medflex/hooks/useIsFocused';
import Logger from '@medflex/utils/Logger';
import useMessages from './useMessages';
import useLastReadMessageIdOfSelectedContact from './useLastReadMessageIdOfSelectedContact';
import Contacts from '../store/models/chatContacts';
import useSelectedContactId from './useSelectedContactId';

const useMarkMessagesAsRead = () => {
  const selectedContactId = useSelectedContactId();
  const lastReadMessageId = useLastReadMessageIdOfSelectedContact();
  const [markedAsReadId, setMarkedAsReadId] = useState();
  const { messages } = useMessages();
  const dispatch = useDispatch();
  const focused = useIsFocused();

  const markRead = message => {
    setMarkedAsReadId(message.id);
    return dispatch[Contacts.name].setLastReadMessage(message);
  };

  const latestMessage = useMemo(
    () => (messages.length > 0 ? messages[messages.length - 1] : null),
    [messages],
  );

  const isUpToDate =
    !latestMessage ||
    (!!lastReadMessageId &&
      (latestMessage.id === lastReadMessageId || markedAsReadId === lastReadMessageId));

  const patch = async () => {
    if (!isUpToDate && latestMessage.id !== 'supportWelcomeMessage') {
      try {
        await dispatch[Contacts.name].setLastReadMessage(latestMessage);
      } catch (e) {
        Logger.error(`useMarkMessagesAsRead(): ${e.message}`);
      }
    }
  };

  useEffect(() => {
    setMarkedAsReadId(null);
  }, [selectedContactId]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (focused) {
      const timer = !isUpToDate ? setTimeout(patch, 2000) : null;
      return () => {
        clearTimeout(timer);
      };
    }
  }, [messages, focused]);

  return markRead;
};

export default useMarkMessagesAsRead;
